import React from 'react'

// Downloading via a hidden anchor with the `download` attribute avoids a real
// page navigation, which would otherwise fire `beforeunload` and tear down the
// header's scroll/modal listeners, leaving the CMP header stuck on screen.
const triggerDownload = (href: string): void => {
  const anchor = document.createElement('a')
  anchor.href = href
  anchor.setAttribute('download', '')
  anchor.style.display = 'none'
  document.body.append(anchor)
  anchor.click()
  anchor.remove()
}

const DownloadListItem = ({
  title,
  link,
  ariaLabel,
  onDownload,
  type,
  size,
}: {
  title?: string
  link: string
  type?: string
  size?: string
  ariaLabel?: string
  onDownload: () => void
}): JSX.Element => {
  const handleDownloadClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault()
    triggerDownload(link)
    onDownload()
  }

  return (
    <a
      className="cmp-download-list__action-wrapper"
      href={link}
      aria-label={ariaLabel || title}
      onClick={handleDownloadClick}
    >
      <div className="cmp-download-list__item">
        <div className="cmp-download-list__content">
          <p className="cmp-download-list__title">
            {title}
            <small className="cmp-download-list__file-info">
              {type}
              {size && <span> ({size})</span>}
            </small>
          </p>
          <div className="cmp-download-list__action">
            <span className="cmp-download-list__action-label" aria-hidden="true" />
          </div>
        </div>
      </div>
    </a>
  )
}

export default DownloadListItem
